<template>
  <p>
    <slot></slot>
  </p>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
p {
  text-align: right;
  margin: auto 0;
  padding-right: 20px;
}
</style>
